import { html, unsafeCSS, type CSSResultGroup } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { LibElement } from '../lib-element';
import toastCss from './lib-toast.css';

@customElement('lib-toast')
export class LibToast extends LibElement {
  static override readonly styles: CSSResultGroup = [LibElement.hostStyles, unsafeCSS(toastCss)];

  @property({ reflect: true }) position = 'top-right';

  override render() {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'lib-toast': LibToast;
  }
}
